export default "__VITE_ASSET__Bgvq9Rhm__"